export default __webpack_public_path__ + "static/media/cover-2.6671cadc.webp";